"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseEventTypeOut = void 0;
class ListResponseEventTypeOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseEventTypeOut.attributeTypeMap;
    }
}
exports.ListResponseEventTypeOut = ListResponseEventTypeOut;
ListResponseEventTypeOut.discriminator = undefined;
ListResponseEventTypeOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<EventTypeOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseEventTypeOut.js.map